<template>
  <transition-group class="Menu" name="menu" tag="div">
    <a
      v-if="!!current"
      key="remove"
      @click="remove"
    ><faicon class="icon" icon="times-circle" /><span>閉じる</span></a>
    <a
      v-for="controller in controllers"
      v-if="!isCurrent(controller) && controller.permission <= role"
      :key="controller.key"
      @click="set(controller.key)"
    ><faicon class="icon" :icon="controller.icon" /><span v-text="controller.text"></span></a>
    <a v-if="tableEdit" :key="97" @click="setTableEdit(false)"><faicon class="icon" icon="lock-open" /><span>配置ロック</span></a>
    <a v-if="!tableEdit" :key="98" @click="setTableEdit(true)"><faicon class="icon" icon="lock" /><span>配置ロック解除</span></a>
    <a @click="subScale" :key="96"><span>縮小-</span></a>
    <a @click="addScale" :key="95"><span>拡大+</span></a>
    <a :key="94"><span>x{{scale}}</span></a>

    <!-- <a :key="96" @click="createTokenURL">URL</a> -->
  </transition-group>
</template>

<script>
export default {
  computed: {
    current() {
      return this.$store.getters['local/mode']
    },
    controllers() {
      return this.$store.getters['controllers/items']
    },
    tableEdit() {
      return this.$store.getters['local/tableEdit']
    },
    scale() {
      return this.$store.getters['local/tableScale']
    },
    role() {
      return this.$store.getters['local/role']
    }
  },
  methods: {
    set(key) {
      this.$store.commit('local/set', { key: 'mode', value: key })
    },
    setTableEdit(value) {
      this.$store.commit('local/set', { key: 'tableEdit', value })
    },
    remove() {
      this.$store.commit('local/set', { key: 'mode', value: null })
    },
    isCurrent({ key }) {
      return this.current === key
    },
    createTokenURL() {
      console.log(111);
    },
    addScale() {
      this.$store.commit('local/addScale')
    },
    subScale() {
      this.$store.commit('local/subScale')
    }
  }
}
</script>


<style scoped lang="scss">
.Menu {
  padding: 8px;
  display: flex;
  justify-content: flex-start;
  position: absolute;
  max-height: 100%;
  max-width: 100%;
  left: 0;
  bottom: 0;
}
a {
  margin-right: 4px;
  padding: 2px 4px;
  display: flex;
  height: 18px;
  transition: all 300ms;
  color: #fff;
  align-items: center;
  background: rgba(0, 0, 0, 0.4);
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.4);
  & + a {}
}
a .icon {
  width: 16px;
  height: 16px;
  color: #fff;
}
a span {
  font-size: 10px;
  color: #fff;
}
a .icon + span {
  margin-left: 5px;
}
.menu-enter, .menu-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.menu-leave-active {
  position: absolute;
}
</style>
